// wordStats.js
// The manuscript's word count, whole book and per chapter, read from the editor.
//
// One count for everything that shows a number: the status bar, the right rail,
// and the counts sent with each save for word goals (backend/utils/word_counts.py).
// The server stores what this returns rather than counting the HTML itself, so
// a goal's "1,200 of 2,000 words" and the count under the page are the same
// number by construction.
//
// Only the page bodies' blocks are read. Counting the whole editor's text also
// picked up whatever sits on the page outside the body, such as page numbers.
import { continuesBlock } from './outline';

const wordsIn = (el) => {
  const text = (el.innerText ?? el.textContent ?? '').replace(/​/g, '').trim();
  return text ? text.split(/\s+/).length : 0;
};

/**
 * @param {Element|null} editorEl the editor root holding `.rv-page` sheets
 * @returns {{ total: number, chapters: { id: string, words: number }[] }}
 *   `chapters` follows the outline's top level: a heading starts a chapter
 *   unless a more senior heading is already open, and the rest of a heading
 *   cut at a page break is the same chapter. Words before the first heading
 *   count toward the total only.
 */
export function manuscriptWordStats(editorEl) {
  const stats = { total: 0, chapters: [] };
  if (!editorEl) return stats;

  let chapter = null;      // { id, words } currently being counted
  let chapterLevel = null; // its heading level
  let prev = null;
  editorEl.querySelectorAll('.rv-page-body').forEach((body) => {
    Array.from(body.children).forEach((el) => {
      if (el.classList?.contains('rv-end-spacer')) return;
      const level = Number(el.getAttribute?.('data-heading-level'));
      const id = el.getAttribute?.('data-block-id');
      const isHeading = level >= 1 && level <= 4;
      if (isHeading && id && !continuesBlock(el, prev)
          && (chapterLevel === null || level <= chapterLevel)) {
        chapter = { id, words: 0 };
        chapterLevel = level;
        stats.chapters.push(chapter);
      }
      const words = wordsIn(el);
      stats.total += words;
      if (chapter) chapter.words += words;
      prev = el;
    });
  });
  return stats;
}
